<template>
  <div>
    <BaseErrors :errors="errors"></BaseErrors>
    <div v-if="brewSession" class="brew-session">
      <h2><router-link :to="{ name: 'recipe-show', params: { id: brewSession.recipeId }}">
        {{brewSession.recipeName}}</router-link>
        <small class="stream-name text-muted">{{streamName}}</small>
      </h2>
      <h5 class="card-subtitle mb-2 text-muted">{{[brewSession.recipeStyle, brewSession.yeast].join(' | ')}}</h5>

      <ul class="brew-session-values">
        <li class="brew-session-value sg">
          <span class="value-name">Specific gravity</span>
          <div class="main-value">{{brewSession.lastUpdate.sg | sg}}</div>
        </li>

        <li class="brew-session-value temperature">
          <span class="value-name">Temperature</span>
          <div class="main-value">{{brewSession.lastUpdate.temperature | temp}}</div>
        </li>

        <li class="brew-session-value attenuation">
          <span class="value-name">Attenuation</span>
          <div class="main-value">{{brewSession.attenuation | percentage}}</div>
        </li>

        <li class="brew-session-value abv">
          <span class="value-name">Current ABV</span>
          <div class="main-value">{{brewSession.fermentationAbv | percentage}}</div>
        </li>
      </ul>

      <div class="graph">
        <FermGraph :brewSessionId="brewSession.id"></FermGraph>
      </div>

      <small class="last-updated" v-if="brewSession.live">
        <time :datetime="brewSession.lastUpdate.timestamp">
          last updated: {{brewSession.lastUpdate.timestamp | timeAgo}}
        </time>
      </small>

    </div>
  </div>
</template>

<script>
    import { HTTP } from '../lib/http';
    import FermGraph from "../components/FermGraph";


    export default {
        name: "brew-session-component",
        components: {
            FermGraph
        },
        props: {
            streamName: String,
            brewSessionId: {
                type: Number
            },
        },
        data() {
            return {
                brewSession: undefined,
                errors: null,
                loading: true
            };
        },
        methods: {
            fetchBrewSession() {
                HTTP
                    .get('brew-sessions/' + this.brewSessionId)
                    .then(response => {
                        this.brewSession = response.data.data;
                    })
                    .catch(err => {
                        this.errors = [err.response.data.errors];
                    })
                    .then(() => {
                        this.loading = false;
                    });
            },
        },
        mounted() {
            if (this.brewSessionId) {
                this.fetchBrewSession();
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "/../assets/scss/_variablesx.scss";

  .brew-session {
    h2 {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 1.5em;

      .stream-name {
        font-size: .6em;
      }
    }
    .card-subtitle {
      font-size: .9em;
    }

    .last-updated {
      display: block;
      text-align: center;
      font-size: .6em;
    }

    .brew-session-values {
      list-style-type: none;
      margin: 1em 0;
      padding: 0;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .last-updated {
        position: relative;
        top: -4em;
      }

      .brew-session-value {
        flex-basis: 45%;
        text-align: center;

        .value-name {
          font-size: .7em;

          & + .main-value {
            margin-top: -.2em;
          }
        }

        .main-value {
          font-size: 3.2em;
          font-weight: 700;
        }
      }
    }
    @media (min-width: 575.98px) {
      max-width: 50%;
      min-width: 575px;

      .brew-session-values {
        flex-wrap: nowrap;
      }

    }
  }
</style>
